import { render, staticRenderFns } from "./liveDes.vue?vue&type=template&id=50b21fd4&scoped=true"
import script from "./liveDes.vue?vue&type=script&lang=js"
export * from "./liveDes.vue?vue&type=script&lang=js"
import style0 from "./liveDes.vue?vue&type=style&index=0&id=50b21fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b21fd4",
  null
  
)

export default component.exports